import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { ArrowForwardIcon, Badge, Button, Typography } from "../../../themeV2";
import kindMeta, { getAccentColor } from "./kindMeta";
import css from "./ResultSection.module.css";
import { cardByKind, cardForItem } from "./SearchResultCard";

export default function ResultSection({ kind, items, onClick, query }) {
  const meta = kindMeta[kind];
  const accent = getAccentColor(meta.paletteKey);
  const Icon = meta.icon;
  const isMixed = kind === "results";

  const browseLink = meta.moreLink
    ? query
      ? `${meta.moreLink}?q=${encodeURIComponent(query)}`
      : meta.moreLink
    : null;

  return (
    <section>
      <div className={css.headerRow}>
        <div className={css.sectionHeader}>
          <Icon color={accent} />
          <Typography
            variant="label-lg"
            weight="bold"
            as="span"
            style={{ color: accent }}
          >
            {meta.label}
          </Typography>
          <Badge variant="count" tone="neutral" count={items.length} />
        </div>
        {browseLink ? (
          <Button
            variant="text"
            size="sm"
            as={Link}
            to={browseLink}
            trailing={<ArrowForwardIcon className={css.arrowIcon} />}
            onClick={onClick}
          >
            Browse all
          </Button>
        ) : null}
      </div>
      <div className={css.items}>
        {isMixed
          ? items.map((item) => {
              const Card = cardForItem(item);
              return <Card onClick={onClick} key={item.id} item={item} />;
            })
          : items.map((item) => {
              const Card = cardByKind[kind];
              return <Card onClick={onClick} key={item.id} item={item} />;
            })}
      </div>
    </section>
  );
}

ResultSection.propTypes = {
  kind: PropTypes.oneOf([
    "influencers",
    "products",
    "characters",
    "franchises",
    "collections",
    "results",
  ]).isRequired,
  items: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  query: PropTypes.string,
};
